import { render, staticRenderFns } from "./GoodsReceiveDetail.vue?vue&type=template&id=11dde5ac&scoped=true"
import script from "./GoodsReceiveDetail.vue?vue&type=script&lang=js"
export * from "./GoodsReceiveDetail.vue?vue&type=script&lang=js"
import style0 from "./GoodsReceiveDetail.vue?vue&type=style&index=0&id=11dde5ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dde5ac",
  null
  
)

export default component.exports